import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { file } from './modules/file'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        file
    },
    state: {
        loggedIn: false //This is just for testing logins
    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage
        })
    ]
})


// WEBPACK FOOTER //
// ./src/store/store.js